import { Renderer, RenderingContext } from "fmko-ts-grid";
import MultiLineWidget from "./MultiLineWidget";

export default class MultiLineRenderer implements Renderer {
    public render(ctx: RenderingContext, o: Object) {
        let lines = <string[]>o;
        let widget = new MultiLineWidget(lines);
        ctx.setWidget(widget);
    }

    public canRender(o: Object): boolean {
        return true;
    }
}
